import React from "react";

import Link from "core/Link";

import { useLoginFlow } from "../Context";

const PasswordLoginViewLink = ({ children }) => {
    const { goToPasswordLoginView } = useLoginFlow();

    return (
        <Link
            isButton
            onClick={e => {
                e.preventDefault();
                goToPasswordLoginView();
            }}
            data-testid="password-login-view-link"
        >
            {children}
        </Link>
    );
};

export default PasswordLoginViewLink;
